import _ from 'lodash';
import moment from 'moment';
import fetchEsimLicenses from '../services/apollo/func/fetch/fetchEsimLicenses';

export const isValidEmail = (email = '') => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email.trim()).toLowerCase());
};

export const formatAddress = (address = '', ward = '', district = '', city = '', country = '') => {
  let add = '';
  if (!_.isEmpty(address)) {
    add += `${address}, `;
  }
  if (!_.isEmpty(ward)) {
    add += `${ward}, `;
  }
  if (!_.isEmpty(district)) {
    add += `${district}, `;
  }
  if (!_.isEmpty(city)) {
    add += `${city}, `;
  }
  if (!_.isEmpty(country)) {
    add += country;
  }
  return add;
};

export const convertSecondTimeToString = (secondTime) => {
  try {
    const hour = Math.floor(secondTime / 60);
    const second = secondTime - hour * 60;
    return moment(`${hour}:${second}`, 'HH:mm').format('HH:mm');
  } catch (error) {
    return '';
  }
};

export const calBMI = (weight, height) => {
  try {
    if (!height || !weight) {
      return '0.0';
    }
    return Number.parseFloat(weight / (height * height)).toFixed(1).toString();
  } catch (error) {
    return '0.0';
  }
};

export const subCountryCodePhone = (phone) => {
  try {
    if (!phone) {
      return phone;
    }
    return phone?.replace('+84', '') || phone;
  } catch (error) {
    return phone;
  }
};

export const convertUtc0ToLocalTime = (time) => {
  try {
    if (!moment(time).isValid()) {
      return time;
    }
    const myUtcOffset = moment().utcOffset();
    return moment(time).utcOffset(myUtcOffset);
  } catch (error) {
    return time;
  }
};

export const formatPascalCase = (text) => {
  if (!text) return '--';
  if (text === 'licenseType') { return 'License type'; }
  if (text === 'dualEsim') { return 'Dual-eSIM'; }
  const removeUnderScope = text.replaceAll('_', ' ');
  const lowerCase = removeUnderScope.toLowerCase();
  return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1);
};

export const getEsimLicenses = async () => {
  try {
    const esimLicenses = await fetchEsimLicenses();
    return esimLicenses;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};
